var map = {
	"./template.bet575": 1080,
	"./template.bet575.tsx": 1080,
	"./template.bet777": 2134,
	"./template.bet777.tsx": 2134,
	"./template.betstride": 2135,
	"./template.betstride.tsx": 2135,
	"./template.buffalobet": 2136,
	"./template.buffalobet.tsx": 2136,
	"./template.chromabet": 1081,
	"./template.chromabet.tsx": 1081,
	"./template.default": 124,
	"./template.default.tsx": 124,
	"./template.epicodds": 2137,
	"./template.epicodds.tsx": 2137,
	"./template.forsport": 1082,
	"./template.forsport.tsx": 1082,
	"./template.gigabet": 2138,
	"./template.gigabet.tsx": 2138,
	"./template.goldenbet888": 2139,
	"./template.goldenbet888.tsx": 2139,
	"./template.goldenrush": 2140,
	"./template.goldenrush.tsx": 2140,
	"./template.hyperbet": 1083,
	"./template.hyperbet.tsx": 1083,
	"./template.juicybet": 2141,
	"./template.juicybet.tsx": 2141,
	"./template.junglebet": 2142,
	"./template.junglebet.tsx": 2142,
	"./template.magnumbet": 1084,
	"./template.magnumbet.tsx": 1084,
	"./template.oldgill": 1085,
	"./template.oldgill.tsx": 1085,
	"./template.puntcity": 2030,
	"./template.puntcity.tsx": 2030,
	"./template.pyramidbet": 1086,
	"./template.pyramidbet.tsx": 1086,
	"./template.slambet": 2143,
	"./template.slambet.tsx": 2143,
	"./template.sterlingparker": 2144,
	"./template.sterlingparker.tsx": 2144,
	"./template.templebet": 2031,
	"./template.templebet.tsx": 2031,
	"./template.titanbet": 2145,
	"./template.titanbet.tsx": 2145,
	"./template.ts": 969,
	"./template.vikingbet": 2146,
	"./template.vikingbet.tsx": 2146
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2423;